module.exports = __webpack_public_path__ + "static/media/icon_checked_blue.50e4729e.svg";